export default {
  submit: 'Представлено',
  numberOfAtt: 'Численность',
  email: 'Электронная почта',
  phone: 'Телефон',
  name: 'Русский',
  company: 'Компания',
  welcome: 'пожаловать на стенд Truking! Пожалуйста, заполните свои данные, и мы отправим вам интересующие вас материалы о продуктах. Спасибо!',
  signIn: 'регистрация',
  ctkj: 'Truking',
  zhCN: '中文',
  enUs: 'English',
  esEs: 'Español',
  deDe: 'Deutsch',
  ruRu: 'Русский язык',
  new_dept: 'Отдел',
  new_title: 'Должность',
  new_nation: 'Страна',
  new_product: 'Тип продукта',
  requiredMsg: 'Заполните обязательное поле.',
  successMsg: 'Успешное представление',
  new_tkproduct: 'Интересующие продукты или решения'
}



// WEBPACK FOOTER //
// ./src/assets/lang/ru-RU.js